import { forwardRef, useRef } from 'react';
import { createReactWrapper } from '../../common/PrefixUtils';
import { handleForwardRef } from '../../common/RefUtils';
export const DataTableCellV2 = forwardRef((props, ref) => {
    const cellRef = useRef();
    const handledRef = handleForwardRef(cellRef, ref);
    return createReactWrapper({
        tagName: 'chameleon-data-table-cell-v2',
        props: Object.assign(Object.assign({}, props), { ref: handledRef }),
        children: props.children,
    });
});
